import "./PrimaryButton.css";

function PrimaryButton({
  children,
  onClick,
  type = "start",
  disabled = false,
  ...props
}) {
  function handleClick(e) {
    e.stopPropagation();
    if (!disabled) onClick(e);
  }

  return (
    <button
      className={`primary-button ${type}`}
      onClick={handleClick}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
}

export default PrimaryButton;
